import React, { Fragment, useEffect, useState } from "react";
// store
import { PAGINATION_LIMIT, API } from "../../../../store/config";
import moment from "moment";
import "moment/locale/sk";
// components
import { Table, Pagination, Icon, Label, Card } from "semantic-ui-react";

// component
function RewardsTable({ rewards }) {
    const [tableData, setTableData] = useState(
        rewards.slice(0, PAGINATION_LIMIT)
    );
    const [isMobile, setIsMobile] = useState(false);

    // set data to table
    useEffect(() => {
        setTableData(rewards.slice(0, PAGINATION_LIMIT));
    }, [rewards]);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleChangePage = (event, data) => {
        setTableData(
            rewards.slice(
                data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT,
                data.activePage * PAGINATION_LIMIT
            )
        );
    };

    // template
    const totalPages = Math.ceil(rewards.length / PAGINATION_LIMIT) || 1;

    return (
        <Fragment>
            {isMobile ? (
                <div>
                    {tableData.length === 0 && (
                        <Card fluid style={{ borderRadius: "16px", textAlign: "center", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.06)" }}>
                            <Card.Content style={{ padding: "2rem 1rem" }}>
                                <div style={{ color: "rgba(0,0,0,0.4)", marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>
                                    <Icon name="inbox" style={{ fontSize: "2.5rem", margin: 0 }} />
                                </div>
                                <strong style={{ fontSize: "0.95rem", color: "rgba(0,0,0,0.7)", lineHeight: 1.4 }}>Vo zvolenom období neboli najdené žiadne záznamy</strong>
                            </Card.Content>
                        </Card>
                    )}
                    {tableData.map((reward) => (
                        <Card key={reward.id} fluid style={{ marginBottom: "1rem", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)", background: "#fff" }}>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: reward.is_paid ? "linear-gradient(135deg, rgba(0,166,81,0.04) 0%, rgba(255,255,255,0) 100%)" : "linear-gradient(135deg, rgba(242,113,28,0.04) 0%, rgba(255,255,255,0) 100%)" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.7rem" }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "rgba(0,0,0,0.45)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "0.25rem" }}>Odmena</div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", lineHeight: 1.2 }}>{reward.reward_number}</div>
                                    </div>
                                    <div style={{ display: "inline-flex", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: reward.is_paid ? "#00a651" : "#f2711c", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: reward.is_paid ? "0 2px 8px rgba(0,166,81,0.25)" : "0 2px 8px rgba(242,113,28,0.25)", marginLeft: "0.5rem" }}>
                                        <Icon name={reward.is_paid ? "check circle" : "clock outline"} style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                        {reward.is_paid ? "Vyplatená" : "Nevyplatená"}
                                    </div>
                                </div>
                                <div style={{ fontSize: "0.85rem", color: "rgba(0,0,0,0.65)", fontWeight: 500 }}>
                                    <Icon name="calendar alternate outline" style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                    {reward.dates.date_from} - {reward.dates.date_to}
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "#fafafa" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.75rem" }}>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="arrow up" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "#00a651" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Zárobok</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#00a651", paddingLeft: "0.15rem" }}>+ {reward.commission.provider_profit} EUR</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="percent" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>AP Provízia</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{reward.commission.commission} EUR</div>
                                    </div>
                                    {reward.paid_when && (
                                        <div style={{ gridColumn: "1 / -1", padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                            <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                                <Icon name="calendar check" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                                <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Vyplatená dňa</span>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{moment(reward.paid_when).format("DD.MM.YYYY")}</div>
                                        </div>
                                    )}
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "0.75rem 1.1rem", background: "var(--primary)", borderTop: "none" }}>
                                <a href={API.GET_REWARDS + reward.id + "/docs"} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", color: "#fff", fontWeight: 700, fontSize: "0.9rem", textDecoration: "none", lineHeight: 1 }}>
                                    <Icon name="file pdf" style={{ margin: 0, fontSize: "1rem" }} />
                                    <span>Zobraziť doklad</span>
                                </a>
                            </Card.Content>
                        </Card>
                    ))}
                    {totalPages > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                            <Pagination
                                defaultActivePage={1}
                                totalPages={totalPages}
                                onPageChange={handleChangePage}
                                boundaryRange={0}
                                siblingRange={1}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <Card fluid style={{ borderRadius: "8px", boxShadow: "none", border: "1px solid #e0e0e0" }}>
                    <Card.Content style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped unstackable style={{ minWidth: "1000px" }}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Číslo odmeny</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Obdobie</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Zárobok</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">AP Provízia</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Vyplatená</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Dátum vyplatenia</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Akcie</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {tableData.length === 0 &&
                                        <Table.Row>
                                            <Table.Cell colSpan={7} style={{ textAlign: "center", fontWeight: "bold" }}>
                                                Vo zvolenom období neboli najdené žiadne záznamy
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                    {tableData.map((reward) => (
                                        <Table.Row key={reward.id}>
                                            <Table.Cell>
                                                <span> {reward.reward_number} </span>
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                {reward.dates.date_from} - {reward.dates.date_to}
                                            </Table.Cell>
                                            <Table.Cell textAlign="left" style={{ color: "green" }}>
                                                + {reward.commission.provider_profit} EUR
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                {reward.commission.commission} EUR
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                {reward.is_paid ? (
                                                    <Label color="green" size="tiny">Áno</Label>
                                                ) : (
                                                    <Label color="red" size="tiny">Nie</Label>
                                                )}
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                {reward.paid_when ? moment(reward.paid_when).format("DD.MM.YYYY") : "-"}
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                <a href={API.GET_REWARDS + reward.id + "/docs"} target="_blank" rel="noopener noreferrer">
                                                    <Icon name="file pdf" style={{ color: "red", fontSize: "1.2rem" }} />
                                                    <span style={{ fontWeight: "bold", color: "black" }}>Zobraziť</span>
                                                </a>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>

                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="7">
                                            <Pagination
                                                defaultActivePage={1}
                                                totalPages={totalPages}
                                                onPageChange={handleChangePage}
                                                boundaryRange={0}
                                                siblingRange={0}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    </Card.Content>
                </Card>
            )}
        </Fragment>
    );
}

export default RewardsTable;
